import axios from 'axios'
import helpers from './../../helpers'

export default {
    getExcuses({commit}, page = 1) {
        commit('clearExcuses')

        axios.get(process.env.VUE_APP_API_URL + `/excuse?page=${page}`)
            .then(response => {
                commit('storeExcuses', response.data)
            })
            .catch(e => {
                helpers.handleMildAxiosError(e)
            })
    },
    getExcuseById({commit}, articleId) {

        axios.get(process.env.VUE_APP_API_URL + `/excuse/${articleId}`)
            .then(response => {
                commit('storeExcuse', response.data.data)
            })
            .catch(e => {
                helpers.handleMildAxiosError(e)
            })
    },
    deleteExcuseByName({commit, dispatch}, name) {
        axios.delete(process.env.VUE_APP_API_URL + '/excuse', {params: {child_name: name}})
            .then(() => {
                helpers.handleSuccessMessage("Einträge für " + name + " gelöscht")
                commit('clearExcuses')
                dispatch('getExcuses')
            })
            .catch(exception => {
                helpers.handleMildAxiosError(exception)
            })
    },
    getExcusesForToday({commit, getters}) {
        if (getters.getExcusesTodayStatus !== 'loading') {
            commit('setExcusesTodayStatus', 'loading')
            axios.get(process.env.VUE_APP_API_URL + `/excuses`)
                .then(response => {
                    commit('storeExcusesForToday', response.data.data)
                    commit('setExcusesTodayStatus', 'loaded')
                })
                .catch(e => {
                    helpers.handleMildAxiosError(e)
                    commit('setExcusesTodayStatus', 'failed')
                })
        }
    },
}
